export default __webpack_public_path__ + "static/media/cleanproqrlogo.a4968819.png";